import { render, staticRenderFns } from "./EditData.vue?vue&type=template&id=47603edb&scoped=true"
import script from "./EditData.vue?vue&type=script&lang=js"
export * from "./EditData.vue?vue&type=script&lang=js"
import style0 from "./EditData.vue?vue&type=style&index=0&id=47603edb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47603edb",
  null
  
)

export default component.exports